// Needed to put this constant in a file outside of dashboard service. It seems I introduced a circular dependency
// (or something??) that caused this constant to be imported without complaint but at run time the value was always undefined.
export const DASHBOARD_SETTINGS_PANEL_GROUP = 'dashboardSettings';
export const DASHBOARD_LEGEND_PANEL_GROUP = 'dashboardLegend';
export const DASHBOARD_LEGEND_HELP_KEY = 'dashboardLegend';
export const DASHBOARD_ITEM_HELP_KEY = 'dashboardItem';
